import {useEffect, useState, useMemo} from 'react';
import {useSelector} from 'react-redux';

const AdminDasTab = ({
    role,
    userId,
    setDasKey
}) => {
    // Filtrage des DAS selon le rôle (memoization pour éviter les recalculs)
    const dasS = useSelector((state) => state.DasReducer.das);

    const dasList = useMemo(() => {
        if (role === 'PA') return dasS;
        if (role === 'MA') return dasS.filter((el) => el.manager?.id === userId);
        return [];
    }, [dasS, role, userId]);

    const [currentTab, setCurrentTab] = useState('');

    // Initialisation du premier onglet
    useEffect(() => {
        if (dasList.length > 0) {
            const firstDas = dasList[0].name;
            setCurrentTab(firstDas);
            setDasKey(firstDas);
        }
    }, [dasList, setDasKey]);

    const handleTabClick = (dasName) => {
        setCurrentTab(dasName);
        setDasKey(dasName);
    };

    // Ne rien afficher si le rôle n'est pas autorisé
    if (role !== 'PA' && role !== 'MA') return null;

    return (
        <div
            className='fixed z-50 flex items-start justify-center w-full max-w-[1600px] overflow-x-auto bg-white'
            style={{boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)'}}
        >
            {dasList.map((el) => (
                <button
                    key={el.name}
                    onClick={() => handleTabClick(el.name)}
                    className='px-6 py-6'
                    aria-pressed={currentTab === el.name}
                >
                    <div
                        className={`pt-2 pb-0.5 px-4 rounded-full text-xl font-bold transition-colors
                            ${currentTab === el.name
                    ? 'background-gradient text-white'
                    : 'bg-white text-[#646464]'}`}
                        style={{fontFamily: 'Din condensed'}}
                    >
                        {el.name}
                    </div>
                </button>
            ))}
        </div>
    );
};

export default AdminDasTab;
